<template>
  <div class="seek_list_page">
    <div class="filter-container" ref="tools">
      <el-form
        :inline="true"
        :model="formInline"
        class="search-container"
        :label-width="labelWidth"
      >
        <!-- 索赔单号 -->
        <el-form-item :label="$t('climant.climantNumber') + ':'">
          <el-input
            v-model="formInline.claimStatementNum"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 索赔单状态 -->
        <el-form-item :label="$t('climant.climantStatus') + ':'">
          <el-select v-model="formInline.status" filterable clearable>
            <el-option :label="$t('home.all')" value=""></el-option>
            <el-option :label="$t('climant.noSubmit')" value="0"></el-option>
            <el-option
              :label="$t('cart.audit')"
              value="1,3,4,15,16,17,18,21"
            ></el-option>
            <el-option :label="$t('home.passed')" value="19"></el-option>
            <!-- <el-option :label="$t('climant.dys')" value="1,4"></el-option>
              <el-option
                :label="$t('climant.dzs')"
                value="3,15,16,17,18,19,21"
              ></el-option> -->
            <el-option :label="$t('climant.rejected')" value="2"></el-option>
            <el-option :label="$t('climant.pendingPreAuth')" value="22"></el-option>
            <!-- <el-option :label="$t('climant.zrpd')" value="6,7"></el-option> -->
            <el-option
              :label="$t('climant.claimsRejected')"
              value="5"
            ></el-option>
            <el-option :label="$t('climant.djs')" value="11"></el-option>
            <el-option
              :label="$t('climant.settleAccounts')"
              value="12"
            ></el-option>
            <el-option :label="$t('home.canceled')" value="13"></el-option>
            <el-option :label="$t('climant.ych')" value="14"></el-option>
          </el-select>
        </el-form-item>
        <!-- VIN -->
        <el-form-item label="VIN:">
          <el-input
            v-model="formInline.vin"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 品牌 -->
        <el-form-item :label="$t('home.brand') + ':'">
          <el-input
            v-model="formInline.carBrand"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 车型 -->
        <el-form-item :label="$t('home.carType') + ':'">
          <el-input
            v-model="formInline.carModel"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 主因故障件名称 -->
        <el-form-item :label="$t('climant.mainFaultName') + ':'">
          <el-input
            v-model="formInline.faultPartName"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 主因故障件件号 -->
        <el-form-item :label="$t('climant.mainFaultNo') + ':'">
          <el-input
            v-model="formInline.faultPartNumber"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 申请时间 -->
        <el-form-item :label="$t('climant.applicationDate') + ':'">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div></div>
        <div>
          <el-button type="primary" class="primary-btn" @click="onSearch">
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button class="primary-btn" plain @click="handleResetQuery">
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      class="tabs-container"
      @tab-click="handleClick"
    >
      <el-tab-pane :label="$t('home.all')" name="all"></el-tab-pane>
      <el-tab-pane :label="$t('climant.drafts')" name="0"></el-tab-pane>
      <el-tab-pane :label="$t('climant.rejected')" name="2"></el-tab-pane>
      <el-tab-pane :label="$t('climant.claimsRejected')" name="5"></el-tab-pane>
      <el-tab-pane
        :label="$t('climant.settleAccounts')"
        name="12"
      ></el-tab-pane>
    </el-tabs>
    <div v-if="activeName === '12'" class="list">
      <div class="table-btn">
        <!-- <el-button
          type="primary"
          class="primary-btn"
          icon="el-icon-download"
          @click="handleExport(2)"
          >{{ $t("climant.exportSpjsd") }}
        </el-button> -->
        <el-button
          type="primary"
          class="primary-btn"
          icon="el-icon-download"
          @click="handleExport(3)"
          >{{ $t("climant.exportSpmxspd") }}
        </el-button>
        <el-button
          type="primary"
          plain
          class="primary-btn"
          icon="el-icon-download"
          @click="handleExport(4)"
          >{{ $t("climant.exportSpmxgzj") }}
        </el-button>
      </div>
      <el-table
        key="1"
        stripe
        border
        ref="singleTable1"
        :data="tableData"
        highlight-current-row
        :max-height="maxHeight"
        :row-class-name="tableRowClassName"
      >
        <!-- 序号 -->
        <el-table-column
          type="index"
          :label="$t('cart.xh')"
          width="50"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 索赔单号 -->
        <el-table-column
          property="claimStatementNum"
          :label="$t('climant.climantNumber')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 品牌 -->
        <el-table-column
          property="carBrand"
          :label="$t('home.brand')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          property="carModel"
          :label="$t('home.carType')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- vin -->
        <el-table-column
          property="vin"
          label="VIN"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 主因故障件名称 -->
        <el-table-column
          property="faultPartName"
          :label="$t('climant.mainFaultName')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 主因故障件件号 -->
        <el-table-column
          property="faultPartNumber"
          :label="$t('climant.mainFaultNo')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 维修方案 -->
        <el-table-column
          prop="repairPlan"
          :label="$t('climant.wxfa')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.repairPlan === 0 ? $t("climant.wx") : "" }}
            {{ scope.row.repairPlan === 1 ? $t("climant.gh") : "" }}
          </template>
        </el-table-column>
        <!-- 审核状态 -->
        <el-table-column
          property="auditResultDisplay"
          :label="$t('cart.auditStatus')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">
              <!-- 待提交 -->
              {{ $t("climant.noSubmit") }}
            </span>
            <span
              v-else-if="
                scope.row.status === 1 ||
                scope.row.status === 3 ||
                scope.row.status === 4 ||
                scope.row.status === 15 ||
                scope.row.status === 16 ||
                scope.row.status === 17 ||
                scope.row.status === 18 ||
                scope.row.status === 21
              "
            >
              <!-- 待审核 -->
              {{ $t("cart.audit") }}
            </span>
            <span v-else-if="scope.row.status === 22">
              <!-- 待预授权 -->
              {{ $t("climant.pendingPreAuth") }}
            </span>
            <span v-else-if="scope.row.status === 19">
              <!-- 已通过：待确认（责任主体） -->
              {{ $t("home.passed") }}
            </span>
            <span v-else-if="scope.row.status === 2">
              <!-- 驳回（预审） -->
              {{ $t("climant.rejected") }}
            </span>
            <!-- <span v-else-if="scope.row.status === 3">
              {{ $t("climant.dzs") }}
            </span> -->
            <!-- 驳回（正审） -->
            <!-- <span v-else-if="scope.row.status === 4">
              {{ $t("climant.zsrejected") }}
            </span> -->
            <span v-else-if="scope.row.status === 5">
              <!-- 已拒赔 -->
              {{ $t("climant.claimsRejected") }}
            </span>
            <!-- 待判责 -->
            <!-- <span v-else-if="scope.row.status === 6">
              {{ $t("climant.dpz") }}
            </span> -->
            <!-- 驳回（待判责） -->
            <!-- <span v-else-if="scope.row.status === 7">
              {{ $t("climant.dpzrejected") }}
            </span> -->
            <!-- 已判责 -->
            <!-- <span v-else-if="scope.row.status === 8">
              {{ $t("climant.ypz") }}
            </span> -->
            <!-- 驳回（已判责） -->
            <!-- <span v-else-if="scope.row.status === 9">
              {{ $t("climant.ypzrejected") }}
            </span> -->
            <!-- 未同意 -->
            <!-- <span v-else-if="scope.row.status === 10">
              {{ $t("climant.noAgree") }}
            </span> -->
            <span v-else-if="scope.row.status === 11">
              <!-- 待结算 -->
              {{ $t("climant.djs") }}
            </span>
            <span v-else-if="scope.row.status === 12">
              <!-- 已结算 -->
              {{ $t("climant.settleAccounts") }}
            </span>
            <span v-else-if="scope.row.status === 13">
              <!-- 已取消 -->
              {{ $t("home.canceled") }}
            </span>
            <span v-else-if="scope.row.status === 14">
              <!-- 已撤回 -->
              {{ $t("climant.ych") }}
            </span>
          </template>
        </el-table-column>
        <!-- 工时费 -->
        <el-table-column
          prop="totalCostOfWork"
          :label="$t('climant.gsf')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 运费 -->
        <el-table-column
          prop="freight"
          :label="$t('climant.transportationCost')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 关税 -->
        <el-table-column
          prop="tariff"
          :label="$t('climant.customs')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 材料费 -->
        <el-table-column
          prop="materialTotalCost"
          :label="$t('climant.materialCost')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 其他费用 -->
        <el-table-column
          prop="otherTotalCost"
          :label="$t('climant.otherCost')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 一次索赔总费用 -->
        <el-table-column
          prop="claimTotalCost"
          :label="$t('climant.ycspfy')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 结算币种 -->
        <el-table-column
          prop="currency"
          :label="$t('climant.currency')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.currency === 0 ? "CNY" : "USD" }}
          </template>
        </el-table-column>
        <!-- 结算人 -->
        <el-table-column
          prop="settlementStaff"
          :label="$t('climant.jsr')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 结算日期 -->
        <el-table-column
          prop="settlementTime"
          :label="$t('climant.jsrq')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('cart.operate')"
          align="center"
          width="110"
          fixed="right"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button type="text" @click="handleDetail(scope.row)">{{
              $t("operate.view")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else class="list">
      <div class="table-btn">
        <!-- 申请索赔 -->
        <el-button
          type="primary"
          class="primary-btn"
          icon="el-icon-plus"
          @click="handleAddOrEdit()"
          >{{ $t("home.applyClaim") }}</el-button
        >
        <el-button
          type="primary"
          class="primary-btn"
          plain
          icon="el-icon-download"
          @click="handleExport(1)"
          >{{ $t("cart.export") }}</el-button
        >
      </div>
      <el-table
        key="2"
        stripe
        border
        ref="singleTable2"
        :data="tableData"
        highlight-current-row
        :row-class-name="tableRowClassName"
        :max-height="maxHeight"
      >
        <!-- 序号 -->
        <el-table-column
          type="index"
          :label="$t('cart.xh')"
          width="50"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 索赔单号 -->
        <el-table-column
          property="claimStatementNum"
          :label="$t('climant.climantNumber')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 品牌 -->
        <el-table-column
          property="carBrand"
          :label="$t('home.brand')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          property="carModel"
          :label="$t('home.carType')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- vin -->
        <el-table-column
          property="vin"
          label="VIN"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 主因故障件名称 -->
        <el-table-column
          property="faultPartName"
          :label="$t('climant.mainFaultName')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 主因故障件件号 -->
        <el-table-column
          property="faultPartNumber"
          :label="$t('climant.mainFaultNo')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 申请时间 -->
        <el-table-column
          property="createTime"
          min-width="160"
          :label="$t('climant.applicationDate')"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 审核状态 -->
        <el-table-column
          property="auditResultDisplay"
          :label="$t('cart.auditStatus')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">
              <!-- 待提交 -->
              {{ $t("climant.noSubmit") }}
            </span>
            <span
              v-else-if="
                scope.row.status === 1 ||
                scope.row.status === 3 ||
                scope.row.status === 4 ||
                scope.row.status === 3 ||
                scope.row.status === 15 ||
                scope.row.status === 16 ||
                scope.row.status === 17 ||
                scope.row.status === 18 ||
                scope.row.status === 21
              "
            >
              <!-- 待审核 -->
              {{ $t("cart.audit") }}
            </span>
            <span v-else-if="scope.row.status === 19">
              <!-- 已通过：待确认（责任主体） -->
              {{ $t("home.passed") }}
            </span>
            <span v-else-if="scope.row.status === 22">
              <!-- 待预授权 -->
              {{ $t("climant.pendingPreAuth") }}
            </span>
            <span v-else-if="scope.row.status === 2">
              <!-- 驳回（预审） -->
              {{ $t("climant.rejected") }}
            </span>
            <!-- 待正审 -->
            <!-- <span v-else-if="scope.row.status === 3">
              {{ $t("climant.dzs") }}
            </span> -->
            <!-- 驳回（正审） -->
            <!-- <span v-else-if="scope.row.status === 4">
              {{ $t("climant.zsrejected") }}
            </span> -->
            <span v-else-if="scope.row.status === 5">
              <!-- 已拒赔 -->
              {{ $t("climant.claimsRejected") }}
            </span>
            <!-- 待判责 -->
            <!-- <span v-else-if="scope.row.status === 6">
              {{ $t("climant.dpz") }}
            </span> -->
            <!-- 驳回（待判责） -->
            <!-- <span v-else-if="scope.row.status === 7">
              {{ $t("climant.dpzrejected") }}
            </span> -->
            <!-- 已判责 -->
            <!-- <span v-else-if="scope.row.status === 8">
              {{ $t("climant.ypz") }}
            </span> -->
            <!-- 驳回（已判责） -->
            <!-- <span v-else-if="scope.row.status === 9">
              {{ $t("climant.ypzrejected") }}
            </span> -->
            <!-- 未同意 -->
            <!-- <span v-else-if="scope.row.status === 10">
              {{ $t("climant.noAgree") }}
            </span> -->
            <span v-else-if="scope.row.status === 11">
              <!-- 待结算 -->
              {{ $t("climant.djs") }}
            </span>
            <span v-else-if="scope.row.status === 12">
              <!-- 已结算 -->
              {{ $t("climant.settleAccounts") }}
            </span>
            <span v-else-if="scope.row.status === 13">
              <!-- 已取消 -->
              {{ $t("home.canceled") }}
            </span>
            <span v-else-if="scope.row.status === 14">
              <!-- 已撤回 -->
              {{ $t("climant.ych") }}
            </span>
            <!-- 待加签审批（部长） -->
            <!-- <span v-else-if="scope.row.status === 15">
              {{ $t("climant.djqspbz") }}
            </span> -->
            <!-- 驳回（部长加签审批） -->
            <!-- <span v-else-if="scope.row.status === 16">
              {{ $t("climant.bhbzjqsp") }}
            </span> -->
            <!-- 待加签审批（章总） -->
            <!-- <span v-else-if="scope.row.status === 17">
              {{ $t("climant.djqspzz") }}
            </span> -->
            <!-- 驳回（章总加签审批） -->
            <!-- <span v-else-if="scope.row.status === 18">
              {{ $t("climant.bhzzjqsp") }}
            </span> -->
            <!-- 待确认（责任主体） -->
            <!-- <span v-else-if="scope.row.status === 19">
              {{ $t("climant.dqrzrzt") }}
            </span> -->
            <!-- 驳回（责任确定） -->
            <!-- <span v-else-if="scope.row.status === 21">
              {{ $t("climant.bhzrqd") }}
            </span> -->
          </template>
        </el-table-column>
        <!-- 审核时间 -->
        <el-table-column
          property="auditTime"
          :label="$t('climant.examineDate')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('cart.operate')"
          :width="{ ru: 380, en: 220, vi: 240, es: 240 }[$i18n.locale] || 200"
          fixed="right"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button type="text" @click="handleDetail(scope.row)">{{
              $t("operate.view")
            }}</el-button>
            <!-- 编辑 -->
            <el-button
              v-if="
                scope.row.status === 0 ||
                scope.row.status === 2 ||
                scope.row.status === 14
              "
              type="text"
              @click="handleAddOrEdit(scope.row)"
              >{{ $t("home.edit") }}</el-button
            >
            <!-- 提交 -->
            <el-button
              v-if="scope.row.status === 0 || scope.row.status === 2"
              type="text"
              @click="
                handleChangeStatus(scope.row, '1', 'climant.submitClimant')
              "
              >{{ $t("seek.submit") }}</el-button
            >
            <!-- 撤回 -->
            <el-button
              v-if="
                scope.row.status === 1 ||
                scope.row.status === 3 ||
                scope.row.status === 4 ||
                scope.row.status === 21 ||
                scope.row.status === 22
              "
              type="text"
              @click="
                handleChangeStatus(scope.row, '14', 'climant.revocateClimant')
              "
              >{{ $t("operate.revocate") }}</el-button
            >
            <!-- 取消 -->
            <el-button
              v-if="
                scope.row.status === 0 ||
                scope.row.status === 1 ||
                scope.row.status === 2 ||
                scope.row.status === 3 ||
                scope.row.status === 4 ||
                scope.row.status === 14 ||
                scope.row.status === 21 ||
                scope.row.status === 22
              "
              type="text"
              @click="
                handleChangeStatus(scope.row, '13', 'climant.cancelClimant')
              "
              >{{ $t("seek.cancel") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- </div> -->
    <div class="fenye">
      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="changePage"
      />
    </div>
  </div>
</template>
<script>
import {
  claimantList,
  submitClaimant,
  cancelClaimant,
  revokeClaimant,
  exportClaim,
  settlementExport,
  checkWarrantyTimeByClaimId, checkWarrantyTime,
} from "@/api/seek";
import {getSession, setStorage, setStorageNew} from "@/util/localStor";
import { getDownloadFiles } from "@/util/downFile";
export default {
  data() {
    const { data, pageNum, pageSize } = this.$route.query.searchObj
      ? JSON.parse(this.$route.query.searchObj)
      : {};

    return {
      activeName: "all", // tab栏激活项
      formInline: {
        status: "",
        claimStatementNum: "",
        faultPartNumber: "",
        faultPartName: "",
        carBrand: "",
        carModel: "",
        createTimeStart: "",
        createTimeEnd: "",
        vin: "",
      },
      nowSearch: {
        status: "",
        claimStatementNum: "",
        faultPartNumber: "",
        faultPartName: "",
        carBrand: "",
        carModel: "",
        createTimeStart: "",
        createTimeEnd: "",
        vin: "",
      },
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 30,
      total: 0,
      modelList: [],
      recordsSearchObj: data,
      maxHeight: null,
      // tableHeight: 300, //表格动态高度
      // screenHeight: 0, //内容区域高度
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "115px",
        en: "220px",
        ru: "305px",
        fa: "148px",
        vi: "205px",
        es: "285px",
      };
      return widthMap[this.$i18n.locale] || "150px";
    },
  },
  mounted() {
    this.$router.replace("/claimant/list");
    this.nowSearch = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.nowSearch;
    this.formInline = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.formInline;
    this.getList();
    // this.updateWindowHeight();
    // window.addEventListener("resize", this.updateWindowHeight);
  },
  watch: {
    "$i18n.locale"(newValue, oldValue) {
      let num = 0;
      if (newValue !== "zh") num = 30;
      // this.updateWindowHeight(num);
    },
  },
  methods: {
    // updateWindowHeight(num) {
    //   if (num) {
    //     this.tableHeight =
    //       this.screenHeight - (this.$refs.stickybox.offsetHeight + 30 + num);
    //   } else {
    //     this.tableHeight =
    //       this.screenHeight - (this.$refs.stickybox.offsetHeight + 30);
    //   }
    //   this.screenHeight = window.innerHeight;

    //   this.$nextTick(() => {
    //     if (this.activeName == 12) {
    //       this.$refs.singleTable1.doLayout();
    //     } else {
    //       this.$refs.singleTable2.doLayout();
    //     }
    //   });
    // },
    // 切换tab状态
    handleClick() {
      this.page = 1;
      this.pageSize = 30;
      this.nowSearch.status = this.activeName === "all" ? "" : this.activeName;
      this.getList();
    },
    // 未读消息数表格行样式标注
    tableRowClassName({ row, rowIndex }) {
      if (row.notificationCount > 0) {
        return "warning-row";
      }
      return "";
    },
    // 每页显示条数
    // handleSizeChange(val) {
    //   this.pageSize = val;
    //   this.getList();
    // },
    // 翻页
    changePage(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 记录当前列表搜索条件
    recordSearchObj() {
      this.$router.replace(
        "/claimant/list?searchObj=" +
          JSON.stringify({
            data: {
              ...this.nowSearch,
              date: this.nowSearch.createTimeStart
                ? [
                    this.nowSearch.createTimeStart.split(" ")[0],
                    this.nowSearch.createTimeEnd.split(" ")[0],
                  ]
                : "",
            },
            pageNum: this.page,
            pageSize: this.pageSize,
          })
      );
    },
    // 查看详情
    handleDetail(data) {
      this.recordSearchObj();
      this.$router.push({
        name: "claimantDetail",
        query: {
          unread: data.notificationCount,
          claimantId: data.claimStatementNum,
        },
      });
      setStorage("claimantData", data);
    },
    // 搜索
    onSearch() {
      this.page = 1;
      this.pageSize = 30;
      this.nowSearch.status = this.formInline.status;
      this.nowSearch.claimStatementNum = this.formInline.claimStatementNum;
      this.nowSearch.faultPartNumber = this.formInline.faultPartNumber;
      this.nowSearch.faultPartName = this.formInline.faultPartName;
      this.nowSearch.carBrand = this.formInline.carBrand;
      this.nowSearch.carModel = this.formInline.carModel;
      this.nowSearch.vin = this.formInline.vin;
      if (this.formInline.date) {
        this.nowSearch.createTimeStart = this.formInline.date[0] + " 00:00:00";
        this.nowSearch.createTimeEnd = this.formInline.date[1] + " 23:59:59";
      } else {
        this.nowSearch.createTimeStart = "";
        this.nowSearch.createTimeEnd = "";
      }
      this.getList();
    },
    // 获取列表
    async getList() {
      const query = {
        data: {
          ...this.nowSearch,
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize,
        },
      };
      const res = await claimantList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        // this.updateWindowHeight();
      } else {
        this.$DonMessage.error(res.message);
      }
      this.getTableHighest(this, "maxHeight");
    },
    // 重置查询条件
    handleResetQuery() {
      // 可能是因为data里面的constxxx前面那一段 导致this.$options.data()报错，没法使用这个重置
      // this.formInline = Object.assign({}, this.$options.data()?.formInline);
      (this.formInline = {
        status: "",
        claimStatementNum: "",
        faultPartNumber: "",
        faultPartName: "",
        carBrand: "",
        carModel: "",
        createTimeStart: "",
        createTimeEnd: "",
        vin: "",
      }),
        this.onSearch();
    },
    // 申请索赔
    handleAddOrEdit(data = {}) {
      this.recordSearchObj();
      setStorageNew("claimantData", data);
      this.$router.push("/newClaimant");
    },
    // 获取客户国家名称
    getCustomerCountryName() {
      const person = getSession("person");
      const nationList = Object.values(getSession("nationList"));
      if (person.customerCountry && nationList.length > 0) {
        const country = nationList.find(item => String(item.id) === String(person.customerCountry));
        return country ? (this.$i18n.locale === "zh" ? country.name : country.enName) : null;
      }
      return null;
    },
    // 导出
    async handleExport(type) {
      const query = {
        data: {
          ...this.nowSearch,
          exportType: type,
          languageType: this.$i18n.locale,
        },
      };
      var res = {};
      if (type === 2) {
        res = await settlementExport(query);
      } else {
        res = await exportClaim(query);
      }
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success(this.$t("request.exportOrder"));
      }
    },
    // 提交 | 取消 | 撤回
    async handleChangeStatus(row, status, title) {
      // 如果是提交操作，先检查质保时间
      if (title === "climant.submitClimant") {
        // try {
          const countryName = this.getCustomerCountryName();
          const checkRes = await checkWarrantyTime({
            data: {
              carModel: row.carModel,
              countryName: countryName,
              salesDate: row.salesDate,
              mileage: row.roadHaul,
              languageType: this.$i18n.locale
            }
          });
          if (checkRes.status == "0" && checkRes.data) {
            await this.$confirm(
              checkRes.data,
              this.$t("request.tips"),
              {
                confirmButtonText: this.$t("seek.yes"),
                cancelButtonText: this.$t("seek.no"),
                type: "warning",
              }
            );
          }
        // } catch (e) {
        //   if (e !== "cancel") {
        //     console.error("质保检查失败", e);
        //   }
        // }
      }

      await this.$confirm(
        `${this.$t(title) + ":" + row.claimStatementNum}？`,
        this.$t("request.tips"),
        {
          cancelButtonClass: "confirm-btn-close",
          confirmButtonClass: "confirm-btn-confirm",
        }
      );
      var res = {};
      if (title === "climant.cancelClimant") {
        res = await cancelClaimant({
          data: {
            claimStatementId: row.claimStatementId,
            status: status,
          },
        });
      } else if (title === "climant.revocateClimant") {
        res = await revokeClaimant({
          data: {
            claimStatementId: row.claimStatementId,
            status: status,
          },
        });
      } else {
        res = await submitClaimant({
          data: {
            claimStatementId: row.claimStatementId,
            status: status,
          },
        });
      }
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("message.czcg"));
        this.getList();
      } else {
        this.$DonMessage.error(res.message);
      }
    },
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.updateWindowHeight);
  },
};
</script>
<style lang="scss" scoped>
::v-deep .list .table-btn {
  margin-top: 0;
}

</style>
